module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"updateAvailable":{"title":"New version of the app is available!","buttonTitle":"Update"}},"fi":{"updateAvailable":{"title":"Sovelluksen uusi versio on saatavilla!","buttonTitle":"Päivitä"}}}')
  delete Component.options._Ctor
}
